// ==================== 返回顶部按钮功能 ====================
(function() {
  // 创建返回顶部按钮元素
  const backToTopBtn = document.createElement('div');
  backToTopBtn.id = 'backToTopBtn';
  backToTopBtn.className = 'back-to-top-button';
  backToTopBtn.setAttribute('aria-label', '返回顶部');
  backToTopBtn.setAttribute('role', 'button');
  backToTopBtn.setAttribute('tabindex', '0');
  
  // 插入 SVG 图标
  backToTopBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <defs>
        <style>.cls-1{fill:#fff;}.cls-2{fill-rule:evenodd;}</style>
      </defs>
      <circle class="cls-1" cx="26.58" cy="25.9" r="21.53"/>
      <g>
        <path class="cls-2" d="M26,0h0A26,26,0,0,1,52,26h0A26,26,0,0,1,0,26H0A26,26,0,0,1,26,0ZM14.62,30a1.25,1.25,0,0,0-.37.91,1.35,1.35,0,0,0,.48,1,1.49,1.49,0,0,0,2-.1L26,22.15l9.26,9.62a1.48,1.48,0,0,0,2,.1A1.31,1.31,0,0,0,37.39,30L27.06,19.23a1.43,1.43,0,0,0-1-.44,1.47,1.47,0,0,0-1.07.44Z"/>
      </g>
    </svg>
  `;
  
  // 添加样式
  const style = document.createElement('style');
  style.textContent = `
    .back-to-top-button {
      position: fixed;
      bottom: 110px;
      right: 12px;
      width: 52px;
      height: 52px;
      background-color: #000;
      border-radius: 50%;
      cursor: pointer;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
      z-index: 9999;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .back-to-top-button.show {
      opacity: 1;
      visibility: visible;
    }
    
    .back-to-top-button:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
    }
    
    .back-to-top-button:active {
      transform: translateY(-1px);
    }
    
    .back-to-top-button svg {
      width: 100%;
      height: 100%;
      display: block;
    }
    
    /* 移动端适配 */
    @media (max-width: 768px) {
      .back-to-top-button {
        bottom: 110px;
        right: 12px;
        width: 46px;
        height: 46px;
      }
    }
  `;
  
  // 页面加载完成后添加按钮和样式
  document.addEventListener('DOMContentLoaded', function() {
    document.head.appendChild(style);
    document.body.appendChild(backToTopBtn);
    
    // 监听页面滚动，控制按钮显示/隐藏
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      // 使用节流优化性能
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(function() {
        // 当页面滚动超过 300px 时显示按钮
        if (window.pageYOffset > 300) {
          backToTopBtn.classList.add('show');
        } else {
          backToTopBtn.classList.remove('show');
        }
      }, 100);
    });
    
    // 点击按钮平滑滚动到顶部
    backToTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    
    // 键盘支持（按 Enter 键触发）
    backToTopBtn.addEventListener('keypress', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  });
})();

